const blueimpMD5 = require('blueimp-md5')

export function hmac(message: string, key: string): string {
  return blueimpMD5(message, key)
}

export function md5(message: string): string {
  return blueimpMD5(message)
}
